import type { OnBoardingStep4Query, UpdateUsersPermissionsUserMutation } from '@edwin-group/people-graphql';

import { initializeApollo } from '../lib/apollo-client';

import requestHandler from '../requestHandler';

import { MUTATION_UPDATE_USER, MUTATION_UPDATE_USER_WEEKLY, QUERY_ONBOARDING_STEP4 } from '@edwin-group/people-graphql';

/**
 * @deprecated Step4 content type has been removed from the backend.
 * Migrate the profile page to use its own roles data source.
 */
export async function fetchOnBoardingStep4() {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.query<OnBoardingStep4Query>({
      query: QUERY_ONBOARDING_STEP4,
    }),
  );

  return data?.step4;
}

/**
 * @deprecated Was used by the onboarding step4 form. Consider moving to a
 * profile-specific service.
 */
export async function updateProfile(id: string, profile: string, gender: string, location: string, ageBracket: string) {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.mutate<UpdateUsersPermissionsUserMutation>({
      mutation: MUTATION_UPDATE_USER,
      variables: {
        id,
        input: {
          profile,
          gender,
          location,
          ageBracket,
        },
      },
    }),
  );
  return data;
}

export async function onCompletedOnBoarding(id: string) {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.mutate<UpdateUsersPermissionsUserMutation>({
      mutation: MUTATION_UPDATE_USER,
      variables: {
        id,
        input: {
          onboardHomeCompleted: true,
        },
      },
    }),
  );

  return data?.updateUsersPermissionsUser?.data?.attributes;
}

export async function onInitOnBoarding(id: string) {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.mutate<UpdateUsersPermissionsUserMutation>({
      mutation: MUTATION_UPDATE_USER,
      variables: {
        id,
        input: {
          onboardingStartDate: new Date().toISOString().split('T')[0],
        },
      },
    }),
  );

  return data?.updateUsersPermissionsUser?.data?.attributes;
}

export async function onCompletedOnBoardingWeeklyQuestion(id: string) {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.mutate<UpdateUsersPermissionsUserMutation>({
      mutation: MUTATION_UPDATE_USER_WEEKLY,
      variables: {
        id,
        input: {
          onboardQuestionsCompleted: true,
        },
      },
    }),
  );

  return data?.updateUsersPermissionsUser?.data?.attributes;
}
